import {
    wwHomeColorsDark,
    wwHomeColorsLight,
    wwHomeColorsRandom,
    wwPlayColorsDark,
    wwPlayColorsLight,
    wwPlayColorsRandom,
} from "./theme";
import { resolveSceneBackground } from "./bgAssets";

export const APPEARANCE_STORAGE_KEY = "ww-mobile-play-appearance";
export const APPEARANCE_DARK = "dark";
export const APPEARANCE_LIGHT = "light";
/** Scene photo from `public/bg_images/word-wheel` (3 days per image). */
export const APPEARANCE_RANDOM = "random";

const MODES = new Set([APPEARANCE_LIGHT, APPEARANCE_DARK, APPEARANCE_RANDOM]);

export function normalizeAppearance(value) {
    const mode = String(value ?? "").trim().toLowerCase();
    return MODES.has(mode) ? mode : APPEARANCE_RANDOM;
}

export function readStoredAppearance() {
    try {
        const value = localStorage.getItem(APPEARANCE_STORAGE_KEY);
        if (value != null && String(value).trim() !== "") {
            return normalizeAppearance(value);
        }
    } catch {
        /* ignore */
    }
    // Default: Image (scene photos, 3 days each) — matches Android.
    return APPEARANCE_RANDOM;
}

export function storeAppearance(appearance) {
    const normalized = normalizeAppearance(appearance);
    try {
        localStorage.setItem(APPEARANCE_STORAGE_KEY, normalized);
    } catch {
        /* ignore */
    }
    return normalized;
}

/**
 * @param {"light"|"dark"|"random"} appearance
 */
export function resolvePlayTheme(appearance) {
    const mode = normalizeAppearance(appearance);
    if (mode === APPEARANCE_DARK) {
        return {
            appearance: mode,
            isDarkPlay: true,
            isRandomScene: false,
            playColors: wwPlayColorsDark,
            playTheme: "dark",
            playBackground:
                "linear-gradient(180deg, #22d3ee 0%, #0284c7 32%, #0c4a6e 68%, #020617 100%)",
            homeColors: wwHomeColorsDark,
            sceneBackground: null,
        };
    }
    if (mode === APPEARANCE_RANDOM) {
        const scene = resolveSceneBackground();
        return {
            appearance: mode,
            isDarkPlay: false,
            isRandomScene: true,
            playColors: wwPlayColorsRandom,
            playTheme: "random",
            playBackground: "transparent",
            homeColors: wwHomeColorsRandom,
            sceneBackground: scene,
        };
    }
    return {
        appearance: mode,
        isDarkPlay: false,
        isRandomScene: false,
        playColors: wwPlayColorsLight,
        playTheme: "light",
        playBackground:
            "linear-gradient(180deg, #38bdf8 0%, #0284c7 32%, #0c4a6e 68%, #031525 100%)",
        homeColors: wwHomeColorsLight,
        sceneBackground: null,
    };
}
